import type { PendingRestoreContext } from '@/composables/useBackState';

export type PageBackRestorer = (pageData: Record<string, unknown>) => void;

export type PageBackRestorers = Partial<Record<string, PageBackRestorer>>;

/**
 * Восстанавливает контекст страницы по pageName из pending restore.
 * Каждая страница-получатель регистрирует обработчик под своим route.name.
 */
export const restoreBackContext = (
    pending: PendingRestoreContext | null,
    restorers: PageBackRestorers,
): boolean => {
    if (!pending?.pageName) {
        return false;
    }

    const restore = restorers[pending.pageName];

    if (!restore) {
        return false;
    }

    restore(pending.pageData);
    return true;
};
